import React, { useRef, useState, useEffect } from 'react';
import {
  Card,
  Typography,
  Button,
  Row,
  Col,
  Image,
  Popconfirm,
  Table,
  message,
  Descriptions,
  Avatar,
  Tag,
  Carousel,
  Divider,
} from 'antd';
import styles from './index.less';
import {
  PlayCircleTwoTone,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  QuestionCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import ModalVideo from '@/components/ModalVideoXg';
import { guuid } from '@/utils/utils';
const { Title, Paragraph } = Typography;

const CourserInfoView = ({
  completeClassInfo,
  completeClassCommentInfo,
  isDetailModalVisible,
}) => {
  const [currentPlayURL, setCurrentURL] = useState();
  const [visible, setVisible] = useState(false);
  const [audioUrl, setAudioUrl] = useState();

  const goPreview = (url) => {
    if (!url) {
      return;
    }
    setCurrentURL(url);
    // setCurrentURL(
    //   'http://1500006899.vod2.myqcloud.com/6c9ade48vodcq1500006899/9ca4ca3d387702291337936819/pZfiUqZf3XIA.mp4',
    // );
    setVisible(true);
  };
  const modalCancel = () => {
    setVisible(false);
  };
  useEffect(() => {
    setAudioUrl(completeClassCommentInfo?.coachSpeechModel?.url);
  }, [completeClassCommentInfo?.coachSpeechModel?.url]);

  useEffect(() => {
    if (!isDetailModalVisible) {
      let musiccontrol = document.querySelector('#myAudio');
      musiccontrol.pause();
    }
  }, [isDetailModalVisible]);

  useEffect(() => {
    if (audioUrl) {
      let musiccontrol = document.querySelector('#myAudio');
      let musicsource = document.querySelector('#audioSorce'); //对应source标签
      musiccontrol.pause();
      musicsource.src = audioUrl;
      musiccontrol.load();
    }
  }, [audioUrl]);

  return (
    <div>
      <Paragraph>
        <blockquote style={{ borderColor: 'skyblue' }}>打卡动态</blockquote>
      </Paragraph>
      <div
        className={styles.row}
        hidden={!completeClassInfo?.classSignModel?.id}
      >
          <Carousel style={{ width: '280px', height: '160px' }}>
            {(completeClassInfo?.classSignModel?.spaceImgList || []).map(
              (item, index) => {
                return (
                  <div key={index} className={styles.signImageContent}>
                    <Image width={'280px'} src={item} />
                  </div>
                );
              },
            )}
          </Carousel>

        <div className={styles.descContent}>
          点评数
          <div>{completeClassInfo?.classSignModel?.commentCount ?? ''}</div>
        </div>
        <div className={styles.descContent}>
          点赞次数
          <div>{completeClassInfo?.classSignModel?.signLikeCount ?? ''}</div>
        </div>
        <div className={styles.descContent}>
          点赞人数
          <div>
            {completeClassInfo?.classSignModel?.signLikePeopleCount ?? ''}
          </div>
        </div>
      </div>

      <Paragraph>
        <blockquote style={{ borderColor: 'skyblue' }}>运动视频</blockquote>
      </Paragraph>

      <div
        className={styles.row}
        hidden={
          !completeClassInfo?.videoHighlightsInfo &&
          !completeClassInfo?.currentTrainingMinutes
        }
      >
        <div className={styles.videoContainer}>
          <div className={styles.signImageContent}>
            <Image
              width={'280px'}
              // height={'160px'}
              preview={false}
              src={completeClassInfo?.videoHighlightsInfo?.videoCoverUrl}
              hidden={!completeClassInfo?.videoHighlightsInfo?.videoCoverUrl}
            />
          </div>
          <PlayCircleTwoTone
            hidden={!completeClassInfo?.videoHighlightsInfo?.videoPlayUrl}
            className={styles.videoIcon}
            onClick={() => {
              goPreview(completeClassInfo?.videoHighlightsInfo?.videoPlayUrl);
            }}
          />
        </div>

        <div className={styles.descContent}>
          训练时长<div>{completeClassInfo?.currentTrainingMinutes ?? ''}</div>
        </div>
        <div className={styles.descContent}>
          热量消耗<div>{completeClassInfo?.currentKcal ?? ''}</div>
        </div>
        <div className={styles.descContent}>
          累计时长<div>{completeClassInfo?.totalTrainingMinutes ?? ''}</div>
        </div>
      </div>

      <Paragraph>
        <blockquote style={{ borderColor: 'skyblue' }}>教练点评</blockquote>
      </Paragraph>
      {(completeClassCommentInfo?.actionGtpText || []).map((item, index) => {
        return (
          <div key={index} className={styles.row}>
            <Avatar
              className={styles.marginRight5}
              src={completeClassCommentInfo?.coachCardModel?.coachHeadImg}
            />
            {`${completeClassCommentInfo?.coachCardModel?.coachNickname}：${item}`}
          </div>
        );
      })}

      <div
        hidden={!completeClassCommentInfo?.coachSpeechModel?.url}
        className={styles.row}
      >
        <Avatar
          className={styles.marginRight5}
          src={completeClassCommentInfo?.coachCardModel?.coachHeadImg}
        />
        {`${completeClassCommentInfo?.coachCardModel?.coachNickname}：`}
        <div className={styles.audioContainer}>
          <audio className={styles.audio} id="myAudio" controls>
            <source
              id="audioSorce"
              // src={completeClassCommentInfo?.coachSpeechModel?.url||undefined}
            ></source>
          </audio>
        </div>
      </div>

      <Paragraph>
        <blockquote style={{ borderColor: 'skyblue' }}>动作建议</blockquote>
      </Paragraph>
      {(completeClassCommentInfo?.myCommentActionList || []).map(
        (item, index) => {
          return (
            <div key={index} className={styles.questionActionContent}>
              <Divider orientation="left" orientationMargin="0">
                {' '}
                {item?.shortName}
              </Divider>

              <div className={styles.questionRow}>
                <div className={styles.questionVideoContainer}>
                  <div className={styles.videoContainer}>
                    <div className={styles.actionImageContent}>
                      <Image
                        width={'206px'}
                        // height={'130px'}
                        preview={false}
                        src={item?.actionReplayUrlModel?.cover}
                      />
                    </div>
                    <div className={styles.questionVideo}>
                      <PlayCircleTwoTone
                        className={styles.questionVideoIcon}
                        onClick={() => {
                          goPreview(item?.actionReplayUrlModel?.url);
                        }}
                      />

                      <div className={styles.actionDesc}>用户动作</div>
                    </div>
                  </div>
                  <div className={styles.videoContainer}>
                    <div className={styles.actionImageContent}>
                      <Image
                        width={'206px'}
                        // height={'130px'}
                        preview={false}
                        src={item?.actionUrlModel?.cover}
                      />{' '}
                    </div>
                    <div className={styles.questionVideo}>
                      <PlayCircleTwoTone
                        className={styles.questionVideoIcon}
                        onClick={() => {
                          goPreview(item?.actionUrlModel?.url);
                        }}
                      />
                      <div className={styles.actionDesc}>课件动作</div>
                    </div>
                  </div>
                </div>

                {/* AI自练课 */}
                <div hidden={completeClassCommentInfo.category != 2}>
                  {/* 已点评 */}
                  <div hidden={item.commentStatus != 1}>
                    {/* 完美动作 */}
                    <div
                      hidden={item.markType != 3}
                      className={styles.descContent}
                    >
                      <div className={styles.commentTag}>
                        <CheckCircleOutlined
                          style={{ marginRight: '5px' }}
                          color="#f9710a"
                        />
                        {'完美完成'}
                      </div>
                      <div className={styles.marginTop10}>
                        这个动作完成得不错，请继续保持 ~
                      </div>
                    </div>
                    {/* 问题动作 */}
                    <div hidden={item.markType != 2}>
                      {(item.problemAndGuideModelList || []).map((problem) => {
                        return (
                          <div key={guuid()} className={styles.descContent}>
                            <div
                              className={styles.commentTag}
                              hidden={!problem.question}
                            >
                              <ExclamationCircleOutlined
                                style={{ marginRight: '5px' }}
                                color="#f9710a"
                              />
                              {problem.question}
                            </div>
                            <div className={styles.marginTop10}>
                              {problem.guide}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {/* 无法点评动作 */}
                    <div
                      className={styles.descContent}
                      hidden={item.markType != 1}
                    >
                      <div
                        className={styles.commentTag}
                        hidden={!item.unableReason}
                      >
                        <QuestionCircleOutlined
                          style={{ marginRight: '5px' }}
                          color="#f9710a"
                        />
                        {item?.unableReason ?? ''}
                      </div>
                      <div className={styles.marginTop10}>
                        {' '}
                        {item?.unableGuide ?? ''}
                      </div>
                    </div>
                  </div>

                  {/* 等待点评 */}
                  <div
                    className={styles.descContent}
                    hidden={item.commentStatus == 1}
                  >
                    <div className={styles.commentTag}>
                      <ClockCircleOutlined
                        style={{ marginRight: '5px' }}
                        color="#f9710a"
                      />
                      {'等待点评'}
                    </div>
                    <div className={styles.marginTop10}>
                      {' '}
                      {'教练正在为你发送指导建议，请稍等...'}
                    </div>
                  </div>
                </div>

                {/* 真人课 */}
                <div
                  hidden={completeClassCommentInfo.category != 3}
                  className={styles.descContent}
                >
                  <div>{`教练评分: ${item.coachRpeScoreDesc ?? '-'}（${
                    item.coachRpeScore ?? '-'
                  }分）`}</div>
                  <div className={styles.marginTop10}>{item.sportSummary}</div>
                </div>
                {/*  */}
              </div>
            </div>
          );
        },
      )}
      <ModalVideo
        visible={visible}
        src={currentPlayURL}
        onCancel={modalCancel}
      />
    </div>
  );
};

export default CourserInfoView;
